import React from 'react';
import { Link } from 'react-router-dom';

const CarCard = ({ car }) => {
  const isSold = car.status === 'Sold' || car.status === 'Sold Out';

  const cardStyle = {
    border: isSold ? '2px solid red' : '1px solid #ddd', // Red border if sold
    borderRadius: '8px',
    overflow: 'hidden',
    background: 'white',
    transition: 'transform 0.2s',
    position: 'relative',
    opacity: isSold ? 0.8 : 1
  };

  // Use currency from car data or default to $
  const currencySymbol = car.currency || '$';
  
  // Use country from car data
  const countryFlag = car.country || '';

  return (
    <div style={cardStyle} className="car-card">
      <div style={{position: 'relative'}}>
        <img src={car.image} alt={`${car.make} ${car.model}`} style={{width: '100%', height: '200px', objectFit: 'cover'}} />
        
        {/* Status Badge */}
        <span style={{
            position:'absolute', top:'10px', left:'10px', 
            background: isSold ? 'red' : 'var(--accent-blue)', 
            color:'white', padding:'4px 8px', fontSize:'0.8rem', borderRadius:'4px',
            animation: isSold ? 'blink 2s infinite' : 'none',
            zIndex: 2
        }}>
          {isSold ? 'SOLD OUT' : car.status}
        </span>

        {/* Country Availability Badge */}
        {countryFlag && (
          <div style={{
            position: 'absolute', top: '10px', right: '10px',
            background: 'rgba(255, 255, 255, 0.95)',
            padding: '4px 8px', borderRadius: '4px', fontSize: '0.85rem',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            fontWeight: 'bold', color: '#051337',
            zIndex: 2, display: 'flex', alignItems: 'center', gap: '5px'
          }}>
             Available in: {countryFlag}
          </div>
        )}
      </div>

      <div style={{padding: '15px'}}>
        <h3 style={{fontSize: '1.2rem'}}>{car.year} {car.make} {car.model}</h3>
        <p style={{color: 'var(--primary-grey)', margin: '5px 0'}}>{car.bodyType} • {car.mileage.toLocaleString()} miles</p>
        
        {/* Updated Price with Currency */}
        <h4 style={{color: 'var(--primary-dark)', fontSize: '1.4rem'}}>
          {currencySymbol}{car.price.toLocaleString()}
        </h4>
        
        <div style={{marginTop: '15px', display: 'flex', gap: '10px'}}>
            {isSold ? (
                 <button disabled style={{
                     flex:1, textAlign:'center', fontSize:'0.9rem', 
                     background: '#ccc', color: '#666', border: 'none', 
                     padding: '10px', cursor: 'not-allowed', borderRadius: '4px'
                 }}>
                    Sold Out
                 </button>
            ) : (
                <Link to={`/vehicle/${car.id}`} className="btn btn-primary" style={{flex:1, textAlign:'center', fontSize:'0.9rem'}}>
                    View Details
                </Link>
            )}
        </div>
      </div>
      <style>{`@keyframes blink { 50% { opacity: 0.5; } }`}</style>
    </div>
  );
};

export default CarCard;